import { useQuery } from '@tanstack/react-query';
import assign from 'assign-deep';

import { ChecklistRepository } from 'data/ChecklistRepository';
import { getUser } from 'utils/user';

import useChecklistItems from './useChecklistItems';

export const getKey = ({ userId, photoSessionId }) => [
  'checklist',
  {
    userId: Number(userId),
    photoSessionId: Number(photoSessionId),
  },
];

const useChecklist = (photoSessionId, options) => {
  const userId = getUser().user_id;

  const { data: checklistItems } = useChecklistItems();

  return useQuery({
    queryKey: getKey({ userId, photoSessionId }),
    queryFn: async () => {
      try {
        const data = await ChecklistRepository.getChecklist({
          userId,
          photoSessionId,
        });
        return data || null;
      } catch (e) {
        return Promise.reject(e);
      }
    },
    enabled: Boolean(userId && photoSessionId && checklistItems),
    select: data => assign(checklistItems, data),
    ...options,
  });
};

export default useChecklist;
